import type { BimActKc2ListItemData } from 'gql/graphql';
import { BimActKc2GroupTypeEnum, CostGroupEnum } from 'gql/graphql';
import type { TGroupedData } from 'pages/Project/Common/ActsKC2ListContainer/helpers';
import { Button, IconExpand, IconKebab, ContextMenu } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import * as R from 'ramda';
import { useCallback, useMemo, useRef, useState } from 'react';

import type { IActKc2OtherItem } from '../../BimWorkOrderActsKc2List';

interface TMenuCellRenderer extends ICellRendererParams<TGroupedData<BimActKc2ListItemData, BimActKc2GroupTypeEnum>> {
    handleDeleteGroup?: (id: number) => void;
    handlerOpenEditGroup?: (id: number) => void;
    onOpenOtherActKc2Details: (act: IActKc2OtherItem) => void;
    onOpenActsSmrDetail: (data: Partial<BimActKc2ListItemData>) => void;
}

export const MenuCellRenderer = (props: TMenuCellRenderer) => {
    const { data, handleDeleteGroup, handlerOpenEditGroup, onOpenOtherActKc2Details, onOpenActsSmrDetail } = props;

    const ref = useRef(null);
    const [isContextOpen, setIsContextOpen] = useState<boolean>(false);

    const onContextMenuButtonClick = useCallback((evt) => {
        evt.stopPropagation();
        setIsContextOpen(R.not);
    }, []);

    const groupKebabMenuItems = useMemo(
        () => [
            {
                label: 'Редактировать',
                action: () => {
                    handlerOpenEditGroup?.(data?.groupId);
                },
            },
            {
                label: 'Удалить',
                action: () => {
                    handleDeleteGroup?.(data?.groupId);
                },
            },
        ],
        [data?.groupId, handleDeleteGroup, handlerOpenEditGroup],
    );

    const onGroupKebabMenuClick = useCallback(
        (item) => () => {
            const { action } = item;

            action?.();
        },
        [],
    );

    if (data?.isGroup && data?.groupType === BimActKc2GroupTypeEnum.Custom) {
        return (
            <>
                <Button
                    ref={ref}
                    onClick={onContextMenuButtonClick}
                    iconLeft={IconKebab}
                    onlyIcon
                    view="clear"
                    size="xs"
                />
                <ContextMenu
                    isOpen={isContextOpen}
                    offset={8}
                    items={groupKebabMenuItems}
                    getItemLabel={R.prop('label')}
                    anchorRef={ref}
                    direction="downStartLeft"
                    getItemOnClick={onGroupKebabMenuClick}
                    onClickOutside={onContextMenuButtonClick}
                />
            </>
        );
    }

    if (data?.isGroup) {
        return '';
    }

    const act: IActKc2OtherItem = {
        id: data?.actId,
        status: data?.status,
        number: Number(data?.number),
        date: data?.actDate,
    };

    const onOpenModalDetail = () => {
        const costGroup = data?.costGroup;

        if (!data) {
            return;
        }

        if (costGroup === CostGroupEnum.Others) {
            onOpenOtherActKc2Details(act);
        }

        if (costGroup === CostGroupEnum.Cmr) {
            onOpenActsSmrDetail(data);
        }
    };

    return <Button onClick={onOpenModalDetail} iconLeft={IconExpand} onlyIcon view="clear" size="xs" />;
};

MenuCellRenderer.displayName = 'MenuCellRenderer';
